<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-8 font-size-16">({{total}}) Usuários cadastrados</div>
            <div class="col-3">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="searchQuery"
                placeholder="Procurar..."
              />
            </div>
            <div class="col-1">
              <button type="button" class="btn btn-sm btn-success" @click="onHandleNewUser">Criar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped mb-0 table-bordered">
              <thead>
                <tr>
                  <th>Nome / E-mail</th>
                  <th width="300">Grupo(s)</th>
                  <th>Admin</th>
                  <th>Ultimo acesso</th>
                  <th width="40">-</th>
                  <th width="40">-</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in paginatedFilteredItems" v-bind:key="index">
                  <td>
                    {{user.name}}
                    <br />
                    {{user.email}}
                  </td>
                  <td v-html="setTeamsHTML(user.squad)"></td>
                  <td>
                    <span
                      class="badge font-size-12"
                      v-bind:class="{'badge-soft-success' : user.role == 'admin', 'badge-soft-dark':user.role == 'user'}"
                    >{{user.role}}</span>
                  </td>
                  <td>19/11/2024 10h40</td>
                  <td>
                    <button
                      type="button"
                      class="btn-theme-circle bg-primary width-xs waves-effect waves-light"
                      @click="onHandleEditUser(user.id)"
                    >
                      <i class="mdi mdi-pencil-outline font-size-14 align-middle"></i>
                    </button>
                  </td>
                  <td>
                    <app-button-delete-confirm @handle="onHandleDelete(user.id)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7">Página {{ currentPage }} de {{ totalPages }}</div>
    <div class="col-5">
      <div class="btn-group float-end">
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="prevPage"
          :disabled="currentPage === 1"
        >
          <i class="fa fa-chevron-left"></i>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import { mapActions } from "vuex";
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    squads: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  components: {
    AppButtonDeleteConfirm
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: ""
    };
  },
  beforeMount() {
    this.setTeams();
    
  },
  computed: {
    filteredItems() {
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        return this.items.filter(
          item =>
            item.name.toLowerCase().includes(query) ||
            item.email.toLowerCase().includes(query) ||
            item.role.toLowerCase().includes(query) ||
            item.squad
              .toString()
              .toLowerCase()
              .includes(query)
        );
      }
      return this.items; // Garantir sempre que retorna um array
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    },
    paginatedFilteredItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredItems.slice(start, end); // Assegure que filteredItems é um array
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1; // Redefine para a primeira página quando o filtro é alterado
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    setTeams() {
      let users = this.items;
      let teams = this.squads;
      for (const user of users) {
        let squads = [];
        if (Object.keys(user.teams).length > 0) {
          for (const ut of user.teams) {
            squads.push(ut.name);
          }
        }
        user.squad = squads;
      }

      return users;
    },
    setTeamsHTML(squad) {
      let html = "";
      if (squad.length > 0) {
        for (let i = 0; i < squad.length; i++) {
          let _css = i % 2 == 0 ? "badge-soft-primary" : "bg-soft-dark";
          html += `<span class="badge ${_css} font-size-12 m-2">${squad[i]}</span>`;
        }
      } else {
        html =
          '<span class="badge badge-soft-secondary font-size-12">Não atribuído</span>';
      }
      return html;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    removerItemPorId(id) {
      const index = this.items.findIndex(item => item.id === id);
      if (index !== -1) {
        this.items.splice(index, 1);
        console.log('removido');
      }
    },
    onHandleDelete(id) {
      this.showLoader(true);
      let _this = this;
      const options = {
        method: "DELETE",
        url: `${process.env.VUE_APP_ROOT_API}user/${id}`,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${
            JSON.parse(this.$ls.get(process.env.VUE_APP_LOCAL_STORAGE_NAME))
              .token
          }`
        }
      };
      this.axios(options)
        .then(function(response) {
          _this.showLoader(false);
          _this.showMessage({
            title: "Excluído com sucesso.",
            css: "bg-success"
          });
          _this.removerItemPorId(id);
        })
        .catch(function(error) {
          _this.showLoader(false);
          console.log(error);
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
      //const response = await this.$AppCallApi("GET", "user/"+id);
    },
    onHandleEditUser(id) {
      //alert(id);
      this.$emit("handle", id);
    },
    onHandleNewUser() {
      this.$emit("handle", null);
    }
  }
};
</script>
<style scoped>
.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
}
</style>